<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <v-layout mb-4>
          <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>

        <v-layout mx-6>
          <v-flex>
            <v-layout style="background-color: #3E7662;">
              <v-flex
                my-4
                ml-8
                style="text-align: left;font-size: 28px;color: white"
                @click="setData"
              >
                <div style="font-weight: bold">
                  แบบตรวจสอบเอกสารชี้แจงข้อมูลแก่อาสาสมัคร
                </div>
                <div style="font-size: 18px;">
                  Consent Form Elements Checklist
                </div>
              </v-flex>
              <v-flex
                ml-8
                pt-8
                pr-8
                style="text-align: right;font-weight: bold;font-size: 13px;color: white"
              >
                <span>RO 04_1.1_2560</span>
              </v-flex>
            </v-layout>

            <!-- Start Form -->

            <!-- Card 1 -->
            <v-card class="mb-12">
              <v-layout pa-12 class="justify-center">
                <v-flex xs10>
                  <!-- row 1 -->
                  <v-layout mb-8>
                    <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                      <b>รหัสโครงร่างการวิจัย</b>
                    </v-flex>
                    <v-flex xs4 class="text-start">
                      <TextfieldForm
                        :model="form.researchCode"
                        hide-detail
                        @update-data="updateData('researchCode', $event)"
                      />
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout mb-8>
                    <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                      <b>ชื่อผู้วิจัยหลัก</b>
                    </v-flex>
                    <v-flex xs4 class="text-start">
                      <TextfieldForm
                        :model="form.firstName"
                        hide-detail
                        @update-data="updateData('firstName', $event)"
                      />
                    </v-flex>
                    <v-flex mx-4 xs1 class="d-flex justify-end align-center">
                      <b>นามสกุล</b>
                    </v-flex>
                    <v-flex>
                      <TextfieldForm
                        :model="form.lastName"
                        hide-detail
                        @update-data="updateData('lastName', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout>
                    <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                      <b>ชื่อโครงการวิจัย (ไทย)</b>
                    </v-flex>
                    <v-flex>
                      <textarea-form hide-detail :model="form.researchName"
                            @update-data="updateData('researchName', $event)"></textarea-form>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Card 2 -->
            <v-card class="mb-12">
              <!-- Table -->
              <v-layout class="table-ro4-1">
                <v-flex class="table-style-ro04-1">
                  <table class="table-fill-ro04-1">
                    <!-- thead 1 -->
                    <thead>
                      <tr style="border-top:5px solid #544A44;">
                        <th width="5%" class="text-center">ข้อ</th>
                        <th class="text-center">
                          หัวข้อการประเมินที่เกี่ยวกับโครงการวิจัย
                        </th>
                        <th width="10%" class="text-center">เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่เกี่ยวข้อง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- isAppropriate1 -->
                      <tr style="border-top: none">
                        <td>
                          <span>1.</span>
                        </td>
                        <td>
                          <div>วัตถุประสงค์ของงานวิจัย</div>
                          <div class="font-weight-medium">
                            แจ้งอาสาสมัครว่า
                            สิ่งส่งตรวจจะถูกนำไปใช้ในงานวิจัยเกี่ยวกับมนุษยพันธุศาสตร์
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox1.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate1')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox1.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate1')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox1.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate1')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate2 -->
                      <tr style="border-top: none">
                        <td>
                          <span>2.</span>
                        </td>
                        <td>
                          <div>
                            ระยะเวลาและรายละเอียดเกี่ยวกับการเก็บสิ่งส่งตรวจ
                          </div>
                          <div class="font-weight-medium">
                            - แจ้งอาสาสมัครว่า
                            ระยะเวลาการเก็บสิ่งส่งตรวจการทำลายเมื่อสิ้นสุดการศึกษา
                            (ถ้าไม่ทำลายต้องแสดงเหตุผล)
                          </div>
                          <div class="font-weight-medium">
                            -
                            ระบุสถานที่เก็บและผู้รับผิดชอบการเก็บรักษาสิ่งส่งตรวจ
                          </div>
                          <div class="font-weight-medium">
                            - การควบคุมคุณภาพของคลังเก็บสิ่งส่งตรวจ
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox2.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate2')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox2.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate2')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox2.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate2')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate3 -->
                      <tr style="border-top: none">
                        <td>
                          <span>3.</span>
                        </td>
                        <td>
                          <div>ความเป็นเจ้าของสิ่งส่งตรวจ</div>
                          <div class="font-weight-medium">
                            - อธิบายว่าใครเป็นเจ้าของสิ่งส่งตรวจ
                          </div>
                          <div class="font-weight-medium">
                            - แจ้งอาสาสมัคร
                            ถ้างานวิจัยจะนำไปสู่ผลประโยชน์ในเชิงพาณิชย์และระบุว่าอาสาสมัครจะได้รับ
                            ผลประโยชน์ด้วยหรือไม่
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox3.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate3')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox3.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate3')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox3.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate3')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate4 -->
                      <tr style="border-top: none">
                        <td>
                          <span>4.</span>
                        </td>
                        <td>
                          <div>การเข้าถึงข้อมูลผลการตรวจทางพันธุกรรม</div>
                          <div class="font-weight-medium">
                            - แจ้งว่า
                            อาสาสมัครจะได้รับข้อมูลผลการตรวจหรือไม่(ถ้าไม่ได้รับ
                            ควรอธิบายเหตุผล)
                          </div>
                          <div class="font-weight-medium">
                            - ถ้ามีการแจ้งผล อธิบายกระบวนการ (เช่น
                            การให้คำปรึกษาทางด้านพันธุศาสตร์) และช่วงเวลา
                            ของการแจ้งผลการตรวจ
                          </div>
                          <div class="font-weight-medium">
                            -
                            ระบุนโยบายการป้องกันการเปิดเผยผลที่เกิดขึ้นโดยไม่ตั้งใจ
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox4.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate4')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox4.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate4')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox4.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate4')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate5 -->
                      <tr style="border-top: none">
                        <td>
                          <span>5.</span>
                        </td>
                        <td>
                          <div>
                            การนำสิ่งส่งตรวจไปใช้ในงานวิจัยอื่น Secondary Use
                          </div>
                          <div class="font-weight-medium">
                            - แจ้งอาสาสมัครว่า
                            ผู้วิจัยอาจนำสิ่งส่งตรวจนี้ไปใช้งานวิจัยอื่น
                            หรือในอนาคต โดยมีรหัสเชื่อมถึงอาสาสมัคร
                          </div>
                          <div class="font-weight-medium">
                            - ขอความยินยอมโดยสมัครใจ
                            ในการนำสิ่งส่งตรวจนี้ไปใช้ในปัจจุบัน และในอนาคต
                          </div>
                          <div class="font-weight-medium">
                            - ให้ทางเลือกแก่อาสาสมัคร
                            ถ้าจะมีการติดต่ออาสาสมัครอีก
                          </div>
                          <div class="font-weight-medium">
                            - อาสาสมัครอาจต้องการจำกัดการใช้สิ่งส่งตรวจ
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox5.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate5')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox5.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate5')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox5.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate5')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate6 -->
                      <tr style="border-top: none">
                        <td>
                          <span>6.</span>
                        </td>
                        <td>
                          <div>ทางเลือก</div>
                          <div class="font-weight-medium">
                            - อาสาสมัครอาจตัดสินใจ
                            ไม่เข้าร่วมในการศึกษาในส่วนเกี่ยวข้องกับพันธุกรรม
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox6.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate6')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox6.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate6')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox6.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate6')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate7 -->
                      <tr style="border-top: none">
                        <td>
                          <span>7.</span>
                        </td>
                        <td>
                          <div>ความเสี่ยง Risks</div>
                          <div class="font-weight-medium">
                            - ความเสี่ยงทางด้านสังคม:
                            การเปิดเผยความลับอาจมีผลต่อความสัมพันธ์และฐานะทางสังคม
                            (เช่น การทำประกันชีวิต การจ้างงาน สิทธิทางกฎหมาย
                            หรือเป็นตราบาป)
                          </div>
                          <div class="font-weight-medium">
                            - ความเสี่ยงทางด้านจิตใจ:
                            การเปิดเผยข้อมูลอาจมีผลต่อจิตใจ
                            ทำให้เกิดความเครียดต่อตนเองและครอบครัว
                            โดยเฉพาะอย่างยิ่ง ถ้าไม่มีวิธีการรักษา
                          </div>
                          <div class="font-weight-medium">
                            - ความเสี่ยงทางกายภาพ:
                            ความเสี่ยงในกระบวนการเก็บสิ่งส่งตรวจเพื่องานวิจัยหรือในกระบวนการทำยีนบำบัด
                          </div>
                          <div class="font-weight-medium">
                            - ความเสี่ยงที่ยังไม่ทราบ:
                            อาสาสมัครควรได้รับการบอกว่า อาจมีความเสี่ยงอื่นๆ
                            ที่ยังไม่สามารถระบุได้ในขณะนี้
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox7.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate7')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox7.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate7')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox7.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate7')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate8 -->
                      <tr style="border-top: none">
                        <td>
                          <span>8.</span>
                        </td>
                        <td>
                          <div>ข้อมูลอื่นๆ เกี่ยวกับความเสี่ยง</div>
                          <div class="font-weight-medium">
                            - ข้อมูลปัจจุบันที่ทันสมัย
                            เกี่ยวกับยีนและโรคที่ทำการวิจัย
                          </div>
                          <div class="font-weight-medium">
                            - มีวิธีการรักษาหรือไม่
                          </div>
                          <div class="font-weight-medium">
                            -
                            ผู้วิจัยจะเก็บสิ่งส่งตรวจหรือเนื้อเยื่อเพิ่มเพื่อวัตถุประสงค์ในการรักษาหรือไม่
                          </div>
                          <div class="font-weight-medium">
                            - งานวิจัยนี้เกี่ยวข้องกับการทำยีนบำบัดหรือไม่
                          </div>
                          <div class="font-weight-medium">
                            - มีสมาชิกครอบครัวของอาสาสมัครในงานวิจัยหรือไม่
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox8.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate8')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox8.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate8')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox8.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate8')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate9 -->
                      <tr style="border-top: none">
                        <td>
                          <span>9.</span>
                        </td>
                        <td>
                          <div>ประโยชน์</div>
                          <div class="font-weight-medium">
                            - แจ้งอาสาสมัคร
                            ถ้าอาสาสมัครจะไม่ได้รับประโยชน์โดยตรง
                          </div>
                          <div class="font-weight-medium">
                            - แจ้งอาสาสมัครว่า
                            ไม่สามารถยืนยันเรื่องประโยชน์ที่คาดว่าจะได้รับ
                          </div>
                          <div class="font-weight-medium">
                            -
                            ผู้วิจัยจะเก็บสิ่งส่งตรวจหรือเนื้อเยื่อเพิ่มเพื่อวัตถุประสงค์ในการรักษาหรือไม่
                          </div>
                          <div class="font-weight-medium">
                            - แจ้งอาสาสมัคร เรื่องประโยชน์ที่คาดว่าจะได้รับ
                            รวมทั้งประโยชน์ในเรื่ององค์ความรู้
                          </div>
                          <div class="font-weight-medium">
                            - ประโยชน์ด้านสุขภาพต่อตัวอาสาสมัคร ครอบครัว สังคม
                            รวมถึงประโยชน์ในระยะยาว
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox9.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate9')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox9.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate9')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox9.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate9')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate10 -->
                      <tr style="border-top: none">
                        <td>
                          <span>10.</span>
                        </td>
                        <td>
                          <div>การรักษาความลับของข้อมูลและความเป็นส่วนตัว</div>
                          <div class="font-weight-medium">
                            <div>
                              - อธิบายกระบวนการรักษาความลับของข้อมูล ได้แก่
                            </div>
                            <div class="pl-4">
                              <ul>
                                <li>
                                  มีการเชื่อมโยงสิ่งส่งตรวจกับอาสาสมัครหรือไม่
                                </li>
                                <li>
                                  มีมาตรการการรักษาความลับของข้อมูลเหมาะสมหรือไม่
                                </li>
                                <li>
                                  อธิบายข้อจำกัดของการรักษาความลับของข้อมูล
                                  (เช่น ใคร สามารถเข้าถึงข้อมูลได้
                                  หรือกรณีใดต้องมีการเปิดเผยข้อมูล)
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="font-weight-medium">
                            - ระบุบุคคลที่สาม ที่อาจเข้าถึงข้อมูล เช่น ครอบครัว
                            นายจ้าง แพทย์ผู้รักษา
                          </div>
                          <div class="font-weight-medium">
                            - พงศาวลีทางพันธุกรรม (pedigree)
                            ไม่มีระบุชื่ออาสาสมัคร ในการตีพิมพ์ผลงานวิจัย
                          </div>
                          <div class="font-weight-medium">
                            - การตีพิมพ์ผลงานวิจัย
                            ไม่มีการเปิดเผยชื่อของอาสาสมัคร
                            (ยกเว้นแต่ได้รับอนุญาต)
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox10.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate10')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox10.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate10')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox10.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate10')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate11 -->
                      <tr style="border-top: none">
                        <td>
                          <span>11.</span>
                        </td>
                        <td>
                          <div>ค่าใช้จ่าย</div>
                          <div class="font-weight-medium">
                            - แจ้งอาสาสมัคร
                            เรื่องค่าใช้จ่ายที่ไม่ครอบคลุมในการวิจัยนี้ เช่น
                            ค่าใช้จ่ายในการให้คำปรึกษา ด้านพันธุกรรมศาสตร์
                            ค่าใช้จ่ายของการปรึกษาปัญหาด้านสุขภาพจิต เป็นต้น
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox11.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate11')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox11.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate11')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox11.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate11')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate12 -->
                      <tr style="border-top: none">
                        <td>
                          <span>12.</span>
                        </td>
                        <td>
                          <div>การมีข้อมูลผลการตรวจที่สำคัญ</div>
                          <div class="font-weight-medium">
                            - อภิปรายแนวทาง
                            เกี่ยวกับความต้องการของอาสาสมัครในการรับทราบข้อมูล
                            ถ้าผลการตรวจในเวลา ต่อมามีความเกี่ยวข้องกับสุขภาพ
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox12.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate12')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox12.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate12')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox12.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate12')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate13 -->
                      <tr style="border-top: none">
                        <td>
                          <span>13.</span>
                        </td>
                        <td>
                          <div>การถอนตัวออกจากโครงการวิจัย</div>
                          <div class="font-weight-medium">
                            - แจ้งว่า
                            อาสาสมัครสามารถถอนตัวออกจากโครงการวิจัยได้ตลอดเวลา
                            โดยไม่มีผลกระทบใดๆ
                          </div>
                          <div class="font-weight-medium">
                            -
                            แจ้งกระบวนการที่อาสาสมัครสามารถขอให้ทำลายสิ่งส่งตรวจได้หรือ
                          </div>
                          <div class="font-weight-medium">
                            -
                            แจ้งกระบวนการที่อาสาสมัครสามารถร้องขอให้ทำสิ่งส่งตรวจเป็นตัวอย่างนิรนาม
                            หรือไม่มีรหัสที่สามารถ เชื่อมโยงถึงตัวอาสาสมัครได้
                          </div>
                          <div class="font-weight-medium">
                            -
                            อธิบายข้อจำกัดของอาสาสมัครในการถอนข้อมูลหรือตัวอย่างสิ่งส่งตรวจทางพันธุกรรม
                          </div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox13.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate13')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox13.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate13')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox13.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate13')"
                          ></v-checkbox>
                        </td>
                      </tr>

                      <!-- isAppropriate14 -->
                      <tr
                        style="border-top: none;border-bottom: 5px solid #544A44;"
                      >
                        <td>
                          <span>14.</span>
                        </td>
                        <td>
                          <div>จำนวนอาสาสมัครที่เข้าร่วมในโครงการวิจัย</div>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            v-model="isCheckbox14.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate14')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox14.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate14')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            v-model="isCheckbox14.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate14')"
                          ></v-checkbox>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Card 3 -->
            <v-card class="mb-12">
              <v-layout pa-12>
                <v-flex class="text-start">
                  <!-- ข้อคิดเห็นและแนะนำ -->
                  <v-layout mb-4>
                    <v-flex>
                      <span class="font-weight-bold">ข้อคิดเห็นและแนะนำ</span>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex>
                      <TextareaForm
                        :model="form.adviceTextBox"
                        @update-data="updateData('adviceTextBox', $event)"
                      />
                    </v-flex>
                  </v-layout>

                  <!-- ผู้ประเมิน -->
                  <v-layout style="margin-top: 150px;">
                    <v-flex
                      shrink
                      mt-4
                      mr-2
                      class="text-start font-weight-bold d-flex align-center"
                    >
                      <span>ผู้ประเมิน</span>
                    </v-flex>
                    <v-flex xs4 class="text-start text-field-center">
                      <v-text-field
                        hide-details
                        v-model="form.signature"
                        color="#3E7662"
                        append-icon="edit"
                      />
                    </v-flex>
                    <v-flex
                      ml-12
                      shrink
                      mt-4
                      mr-2
                      class="text-start font-weight-bold d-flex align-center"
                    >
                      <span>คนที่</span>
                    </v-flex>
                    <v-flex xs1 class="text-start text-field-center">
                      <v-text-field
                        hide-details
                        v-model="form.order"
                        color="#3E7662"
                      />
                    </v-flex>
                  </v-layout>

                  <!-- Date -->
                  <v-layout mt-8 style="margin-bottom: 100px;">
                    <v-flex xs3>
                      <DateInputForm
                        :model="dateChange"
                        @update-data="updateDate('date', $event)"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout class="pl-12 pb-12">
                <v-flex class="text-start font-weight-bold">
                  <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Button Save -->
            <v-layout mt-8>
              <v-flex mb-12 style="text-align: right;">
                <v-layout>
                  <v-flex>
                    <v-btn
                      style="color: #3E7662"
                      class="mx-4"
                      depressed
                      color="#ffffff"
                      @click="$router.go(-1)"
                      >ย้อนกลับ</v-btn
                    >
                    <v-btn depressed dark color="#3E7662" @click="save">
                      <span>บันทึกข้อมูล</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-pageAndLine="fullpageAndLine"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";

export default {
  name: "FormRO02",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    form: {
      researchID: "",
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      isAppropriate1: "",
      isAppropriate2: "",
      isAppropriate3: "",
      isAppropriate4: "",
      isAppropriate5: "",
      isAppropriate6: "",
      isAppropriate7: "",
      isAppropriate8: "",
      isAppropriate9: "",
      isAppropriate10: "",
      isAppropriate11: "",
      isAppropriate12: "",
      isAppropriate13: "",
      isAppropriate14: "",
      adviceTextBox: "",
      signature: "",
      order: "",
      date: "",
    },
    isCheckbox1: { checkbox1: false, checkbox2: false },
    isCheckbox2: { checkbox1: false, checkbox2: false },
    isCheckbox3: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox4: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox5: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox6: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox7: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox8: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox9: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox10: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox11: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox12: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox13: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox14: { checkbox1: false, checkbox2: false, checkbox3: false },
    dateChange: "",
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    this.form.researchCode = this.$route.query.researchCode;
    this.form.researchName = this.$route.query.researchName;
    this.form.firstName = this.$route.query.firstName;
    this.form.lastName = this.$route.query.lastName;
    //this.form.signature = this.user.thName;

    this.updateDate("date", { date: new Date().toISOString().substr(0, 10) });

    this.getRO04_2();
  },
  methods: {
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      if (name === "date") {
        this.form.date = val.date;
        this.dateChange = this.changeDate(val.date);
      }
      if (name === "estimateDateGet") {
        this.form.date = val;
        this.dateChange = this.changeDate(val);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    clearRadio(val, name) {
      if (name === "recommendToMeet") {
        if (val === 1) {
          this.form.recommendToMeet = val.toString();
          this.form.expertConsultant = "";
        }
      }
    },
    checkbox(no, name) {
      switch (name) {
        case "isAppropriate1":
          switch (no) {
            case 1:
              this.isCheckbox1.checkbox1 = true;
              this.isCheckbox1.checkbox2 = false;
              this.isCheckbox1.checkbox3 = false;
              this.form.isAppropriate1 = no;
              break;
            case 2:
              this.isCheckbox1.checkbox1 = false;
              this.isCheckbox1.checkbox2 = true;
              this.isCheckbox1.checkbox3 = false;
              this.form.isAppropriate1 = no;
              break;
            case 3:
              this.isCheckbox1.checkbox1 = false;
              this.isCheckbox1.checkbox2 = false;
              this.isCheckbox1.checkbox3 = true;
              this.form.isAppropriate1 = no;
              break;
          }
          break;
        case "isAppropriate2":
          switch (no) {
            case 1:
              this.isCheckbox2.checkbox1 = true;
              this.isCheckbox2.checkbox2 = false;
              this.isCheckbox2.checkbox3 = false;
              this.form.isAppropriate2 = no;
              break;
            case 2:
              this.isCheckbox2.checkbox1 = false;
              this.isCheckbox2.checkbox2 = true;
              this.isCheckbox2.checkbox3 = false;
              this.form.isAppropriate2 = no;
              break;
            case 3:
              this.isCheckbox2.checkbox1 = false;
              this.isCheckbox2.checkbox2 = false;
              this.isCheckbox2.checkbox3 = true;
              this.form.isAppropriate2 = no;
              break;
          }
          break;
        case "isAppropriate3":
          switch (no) {
            case 1:
              this.isCheckbox3.checkbox1 = true;
              this.isCheckbox3.checkbox2 = false;
              this.isCheckbox3.checkbox3 = false;
              this.form.isAppropriate3 = no;
              break;
            case 2:
              this.isCheckbox3.checkbox1 = false;
              this.isCheckbox3.checkbox2 = true;
              this.isCheckbox3.checkbox3 = false;
              this.form.isAppropriate3 = no;
              break;
            case 3:
              this.isCheckbox3.checkbox1 = false;
              this.isCheckbox3.checkbox2 = false;
              this.isCheckbox3.checkbox3 = true;
              this.form.isAppropriate3 = no;
              break;
          }
          break;
        case "isAppropriate4":
          switch (no) {
            case 1:
              this.isCheckbox4.checkbox1 = true;
              this.isCheckbox4.checkbox2 = false;
              this.isCheckbox4.checkbox3 = false;
              this.form.isAppropriate4 = no;
              break;
            case 2:
              this.isCheckbox4.checkbox1 = false;
              this.isCheckbox4.checkbox2 = true;
              this.isCheckbox4.checkbox3 = false;
              this.form.isAppropriate4 = no;
              break;
            case 3:
              this.isCheckbox4.checkbox1 = false;
              this.isCheckbox4.checkbox2 = false;
              this.isCheckbox4.checkbox3 = true;
              this.form.isAppropriate4 = no;
              break;
          }
          break;
        case "isAppropriate5":
          switch (no) {
            case 1:
              this.isCheckbox5.checkbox1 = true;
              this.isCheckbox5.checkbox2 = false;
              this.isCheckbox5.checkbox3 = false;
              this.form.isAppropriate5 = no;
              break;
            case 2:
              this.isCheckbox5.checkbox1 = false;
              this.isCheckbox5.checkbox2 = true;
              this.isCheckbox5.checkbox3 = false;
              this.form.isAppropriate5 = no;
              break;
            case 3:
              this.isCheckbox5.checkbox1 = false;
              this.isCheckbox5.checkbox2 = false;
              this.isCheckbox5.checkbox3 = true;
              this.form.isAppropriate5 = no;
              break;
          }
          break;
        case "isAppropriate6":
          switch (no) {
            case 1:
              this.isCheckbox6.checkbox1 = true;
              this.isCheckbox6.checkbox2 = false;
              this.isCheckbox6.checkbox3 = false;
              this.form.isAppropriate6 = no;
              break;
            case 2:
              this.isCheckbox6.checkbox1 = false;
              this.isCheckbox6.checkbox2 = true;
              this.isCheckbox6.checkbox3 = false;
              this.form.isAppropriate6 = no;
              break;
            case 3:
              this.isCheckbox6.checkbox1 = false;
              this.isCheckbox6.checkbox2 = false;
              this.isCheckbox6.checkbox3 = true;
              this.form.isAppropriate6 = no;
              break;
          }
          break;
        case "isAppropriate7":
          switch (no) {
            case 1:
              this.isCheckbox7.checkbox1 = true;
              this.isCheckbox7.checkbox2 = false;
              this.isCheckbox7.checkbox3 = false;
              this.form.isAppropriate7 = no;
              break;
            case 2:
              this.isCheckbox7.checkbox1 = false;
              this.isCheckbox7.checkbox2 = true;
              this.isCheckbox7.checkbox3 = false;
              this.form.isAppropriate7 = no;
              break;
            case 3:
              this.isCheckbox7.checkbox1 = false;
              this.isCheckbox7.checkbox2 = false;
              this.isCheckbox7.checkbox3 = true;
              this.form.isAppropriate7 = no;
              break;
          }
          break;
        case "isAppropriate8":
          switch (no) {
            case 1:
              this.isCheckbox8.checkbox1 = true;
              this.isCheckbox8.checkbox2 = false;
              this.isCheckbox8.checkbox3 = false;
              this.form.isAppropriate8 = no;
              break;
            case 2:
              this.isCheckbox8.checkbox1 = false;
              this.isCheckbox8.checkbox2 = true;
              this.isCheckbox8.checkbox3 = false;
              this.form.isAppropriate8 = no;
              break;
            case 3:
              this.isCheckbox8.checkbox1 = false;
              this.isCheckbox8.checkbox2 = false;
              this.isCheckbox8.checkbox3 = true;
              this.form.isAppropriate8 = no;
              break;
          }
          break;
        case "isAppropriate9":
          switch (no) {
            case 1:
              this.isCheckbox9.checkbox1 = true;
              this.isCheckbox9.checkbox2 = false;
              this.isCheckbox9.checkbox3 = false;
              this.form.isAppropriate9 = no;
              break;
            case 2:
              this.isCheckbox9.checkbox1 = false;
              this.isCheckbox9.checkbox2 = true;
              this.isCheckbox9.checkbox3 = false;
              this.form.isAppropriate9 = no;
              break;
            case 3:
              this.isCheckbox9.checkbox1 = false;
              this.isCheckbox9.checkbox2 = false;
              this.isCheckbox9.checkbox3 = true;
              this.form.isAppropriate9 = no;
              break;
          }
          break;
        case "isAppropriate10":
          switch (no) {
            case 1:
              this.isCheckbox10.checkbox1 = true;
              this.isCheckbox10.checkbox2 = false;
              this.isCheckbox10.checkbox3 = false;
              this.form.isAppropriate10 = no;
              break;
            case 2:
              this.isCheckbox10.checkbox1 = false;
              this.isCheckbox10.checkbox2 = true;
              this.isCheckbox10.checkbox3 = false;
              this.form.isAppropriate10 = no;
              break;
            case 3:
              this.isCheckbox10.checkbox1 = false;
              this.isCheckbox10.checkbox2 = false;
              this.isCheckbox10.checkbox3 = true;
              this.form.isAppropriate10 = no;
              break;
          }
          break;
        case "isAppropriate11":
          switch (no) {
            case 1:
              this.isCheckbox11.checkbox1 = true;
              this.isCheckbox11.checkbox2 = false;
              this.isCheckbox11.checkbox3 = false;
              this.form.isAppropriate11 = no;
              break;
            case 2:
              this.isCheckbox11.checkbox1 = false;
              this.isCheckbox11.checkbox2 = true;
              this.isCheckbox11.checkbox3 = false;
              this.form.isAppropriate11 = no;
              break;
            case 3:
              this.isCheckbox11.checkbox1 = false;
              this.isCheckbox11.checkbox2 = false;
              this.isCheckbox11.checkbox3 = true;
              this.form.isAppropriate11 = no;
              break;
          }
          break;
        case "isAppropriate12":
          switch (no) {
            case 1:
              this.isCheckbox12.checkbox1 = true;
              this.isCheckbox12.checkbox2 = false;
              this.isCheckbox12.checkbox3 = false;
              this.form.isAppropriate12 = no;
              break;
            case 2:
              this.isCheckbox12.checkbox1 = false;
              this.isCheckbox12.checkbox2 = true;
              this.isCheckbox12.checkbox3 = false;
              this.form.isAppropriate12 = no;
              break;
            case 3:
              this.isCheckbox12.checkbox1 = false;
              this.isCheckbox12.checkbox2 = false;
              this.isCheckbox12.checkbox3 = true;
              this.form.isAppropriate12 = no;
              break;
          }
          break;
        case "isAppropriate13":
          switch (no) {
            case 1:
              this.isCheckbox13.checkbox1 = true;
              this.isCheckbox13.checkbox2 = false;
              this.isCheckbox13.checkbox3 = false;
              this.form.isAppropriate13 = no;
              break;
            case 2:
              this.isCheckbox13.checkbox1 = false;
              this.isCheckbox13.checkbox2 = true;
              this.isCheckbox13.checkbox3 = false;
              this.form.isAppropriate13 = no;
              break;
            case 3:
              this.isCheckbox13.checkbox1 = false;
              this.isCheckbox13.checkbox2 = false;
              this.isCheckbox13.checkbox3 = true;
              this.form.isAppropriate13 = no;
              break;
          }
          break;
        case "isAppropriate14":
          switch (no) {
            case 1:
              this.isCheckbox14.checkbox1 = true;
              this.isCheckbox14.checkbox2 = false;
              this.isCheckbox14.checkbox3 = false;
              this.form.isAppropriate14 = no;
              break;
            case 2:
              this.isCheckbox14.checkbox1 = false;
              this.isCheckbox14.checkbox2 = true;
              this.isCheckbox14.checkbox3 = false;
              this.form.isAppropriate14 = no;
              break;
            case 3:
              this.isCheckbox14.checkbox1 = false;
              this.isCheckbox14.checkbox2 = false;
              this.isCheckbox14.checkbox3 = true;
              this.form.isAppropriate14 = no;
              break;
          }
          break;
      }
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;
          this.$store
            .dispatch("FormRO/saveRO04_2", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // })
              // this.isLoading = false;
            });
        }
      });
    },
    getRO04_2() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRO/getRO04_2", this.$route.query.id)
        .then((res) => {
          if (res !== "don't have ro04_2 yet") {
            console.log("getRO04_2 : ", res);
            this.form.researchID = res.researchID;
            this.form.researchCode = res.researchCode;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchName = res.researchName;
            this.checkbox(res.isAppropriate1, "isAppropriate1");
            this.checkbox(res.isAppropriate2, "isAppropriate2");
            this.checkbox(res.isAppropriate3, "isAppropriate3");
            this.checkbox(res.isAppropriate4, "isAppropriate4");
            this.checkbox(res.isAppropriate5, "isAppropriate5");
            this.checkbox(res.isAppropriate6, "isAppropriate6");
            this.checkbox(res.isAppropriate7, "isAppropriate7");
            this.checkbox(res.isAppropriate8, "isAppropriate8");
            this.checkbox(res.isAppropriate9, "isAppropriate9");
            this.checkbox(res.isAppropriate10, "isAppropriate10");
            this.checkbox(res.isAppropriate11, "isAppropriate11");
            this.checkbox(res.isAppropriate12, "isAppropriate12");
            this.checkbox(res.isAppropriate13, "isAppropriate13");
            this.checkbox(res.isAppropriate14, "isAppropriate14");
            this.form.adviceTextBox = res.adviceTextBox;
            this.form.signature = res.signature;
            this.form.order = res.order;
            this.updateDate("estimateDateGet", res.date);
          }
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    setData() {
      this.form.researchCode = "researchCodeTest";
      this.form.firstName = "firstNameTest";
      this.form.lastName = "lastNameTest";
      this.form.researchName = "researchNameTest";
      this.checkbox(1, "isAppropriate1");
      this.checkbox(1, "isAppropriate2");
      this.checkbox(1, "isAppropriate3");
      this.checkbox(1, "isAppropriate4");
      this.checkbox(1, "isAppropriate5");
      this.checkbox(1, "isAppropriate6");
      this.checkbox(1, "isAppropriate7");
      this.checkbox(1, "isAppropriate8");
      this.checkbox(1, "isAppropriate9");
      this.checkbox(1, "isAppropriate10");
      this.checkbox(1, "isAppropriate11");
      this.checkbox(1, "isAppropriate12");
      this.checkbox(1, "isAppropriate13");
      this.checkbox(1, "isAppropriate14");
      this.form.adviceTextBox = "adviceTextBoxTest";
      this.form.signature = "signatureTest";
      this.form.order = 3;
      this.updateDate("estimateDateGet", "2020-02-01");
    },
  },
};
</script>

<style lang="scss">
.table-ro4-1 {
  /*** Table Styles **/
  .table-style-ro04-1 {
    .v-input__slot {
      align-items: center;
      justify-content: center;
    }
    .table-fill-ro04-1 {
      background: white;
      border-radius: 3px;
      border-collapse: collapse;
      margin: auto;
      padding: 5px;
      width: 100%;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      animation: float 5s infinite;
      /*border-bottom: 5px solid #544A44;*/
    }

    th {
      color: #ffffff;
      background: #3e7662;
      /*border-top:5px solid #544A44;*/
      border-right: 0.75px solid gray;
      font-weight: 700;
      padding: 15px;
      vertical-align: middle;
    }
    tr {
      border-top: 1px solid #544a44;
      border-bottom-: 1px solid #544a44;
    }
    th:first-child {
      border-top-left-radius: 3px;
    }

    th:last-child {
      border-top-right-radius: 3px;
      border-right: none;
    }

    tr:first-child {
      /*border-top: none;*/
    }

    tr:last-child {
      /*border-bottom:5px solid #544A44;*/
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

    td {
      background: #ffffff;
      padding: 10px 30px 10px 30px;
      text-align: left;
      vertical-align: middle;
      font-weight: 700;
      color: black;
      border-right: 0.5px solid gray;
      border-top: 0.5px solid gray;
    }

    td:last-child {
      border-right: 0px;
    }

    th.text-left {
      text-align: left;
    }

    th.text-center {
      text-align: center;
    }

    th.text-right {
      text-align: right;
    }

    td.text-left {
      text-align: left;
    }

    td.text-center {
      text-align: center;
    }

    td.text-right {
      text-align: right;
    }
  }
}

.text-field-color {
  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #cc3d45;
  }
}
.text-field-margin {
  .v-text-field {
    padding: 0;
    margin: 0;
  }
}
</style>
